import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 1,
  class: ""
}

import {onMounted, Ref, ref} from "vue";
import {store} from "@/store";
import {client} from '@/shared';
import {AddBookmark, AddBookmarkResponse, DeleteBookmark, DeleteBookmarkResponse} from "@/dtos";
import {trackEvent} from '@/shared';


export default /*@__PURE__*/_defineComponent({
  __name: 'Bookmarking',
  props: {
    id: String,
    type: String
},
  setup(__props) {

// @ts-ignore
const props = __props;

const id: Ref<String> = ref(props.id);
let isBookmarked: Ref<Boolean> = ref(false);
let type = props.type ?? "card";

onMounted((): void => {
    if (store.saUserSession.bookmarkedItems.includes(id.value.toLowerCase())) {
        isBookmarked.value = true;
    }
});

const addBookmark = async () => {
    if (!store.saUserSession.isAuthenticated) {
        store.showLoginDialog = true;
        return;
    }
    await client.post<AddBookmarkResponse>(new AddBookmark({id: id.value}))
        .then(() => {
            isBookmarked.value = true;
            trackEvent( 'bookmark', {
                content_id: id.value,
                content_type: id.value.split('/', 1)
            });
        })
        .catch(e => {
            console.log(e);
            if (e.responseStatus.errorCode === "Forbidden") {
                store.userPromptTitle = "Oops...";
                store.userPromptContent = e.responseStatus.message;
                store.showUserPrompt = true;
                return;
            }
        });

};

const removeBookmark = async () => {
    if (!store.saUserSession.isAuthenticated) {
        store.showLoginDialog = true;
        return;
    }
    await client.delete<DeleteBookmarkResponse>(new DeleteBookmark({id: id.value}))
        .then(() => {
            isBookmarked.value = false;
        })
};

return (_ctx: any,_cache: any) => {
  return (_unref(type) === 'page')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isBookmarked))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              "aria-label": "Bookmark this page",
              class: "relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs",
              href: "#",
              onClick: _withModifiers(removeBookmark, ["prevent"])
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "text-lg fas fa-bookmark" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              "aria-label": "Bookmark this page",
              class: "relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs",
              href: "#",
              onClick: _withModifiers(addBookmark, ["prevent"])
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "text-lg far fa-bookmark" }, null, -1)
            ])))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_unref(isBookmarked))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "px-3 py-2 rounded-xl text-clay-800 hover:text-clay-800",
              "aria-label": "Remove bookmark",
              href: "#",
              onClick: _withModifiers(removeBookmark, ["prevent"])
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fas fa-bookmark" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "px-3 py-2 rounded-xl text-clay-800 hover:bg-clay-100 hover:text-clay-800",
              "aria-label": "Add bookmark",
              href: "#",
              onClick: _withModifiers(addBookmark, ["prevent"])
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "far fa-bookmark" }, null, -1)
            ])))
      ]))
}
}

})